import script from "./AnswersUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswersUpload.vue?vue&type=script&setup=true&lang=js"

import "./AnswersUpload.vue?vue&type=style&index=0&id=02abb1c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02abb1c0"]])

export default __exports__